import { useState } from 'react'

import { useSaveSettings, useSettings } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { fehlertext } from '../../api/client'

/**
 * Wie großzügig aus einer Aufzeichnung Vorschläge werden.
 *
 * **Diese zwei Zahlen gab es im Server von Anfang an, in der Oberfläche
 * nicht** — und die Installationsanleitung behauptete trotzdem, sie seien
 * hier einstellbar. Wer also mit „keine längeren Aufenthalte" dastand, konnte
 * nichts dagegen tun, ohne die Schnittstelle von Hand aufzurufen. Aus dem
 * Betrieb gemeldet.
 *
 * Eigene Karte und nicht bei den Bildern: die dort haben eine Decke in der
 * `.env` (sie schützen das Hosting-Paket), diese beiden haben keine. Eine
 * Suchweite kostet nichts — sie entscheidet nur, was als Aufenthalt gilt.
 */
export function ErkennungCard() {
  const t = useTexte()
  const settings = useSettings()
  const save = useSaveSettings()
  const [entwurf, setEntwurf] = useState<{ radius?: string; minuten?: string }>({})
  const [gemeldet, setGemeldet] = useState(false)

  const daten = settings.data
  // Ohne Decke ist dieses Konto keine Verwaltung -- der Server hat entschieden.
  if (!daten?.ceiling || !daten.limits) return null

  const werte = daten.settings
  const grenzen = daten.limits

  const radius = entwurf.radius ?? String(werte.stop_radius_m)
  const minuten = entwurf.minuten ?? String(werte.stop_minutes)

  function geaendert(): { stop_radius_m?: number; stop_minutes?: number } {
    const teil: { stop_radius_m?: number; stop_minutes?: number } = {}
    const r = Number(radius)
    const m = Number(minuten)
    if (Number.isInteger(r) && r !== werte.stop_radius_m) teil.stop_radius_m = r
    if (Number.isInteger(m) && m !== werte.stop_minutes) teil.stop_minutes = m
    return teil
  }

  const offen = Object.keys(geaendert()).length > 0

  return (
    <div className="card card--seite">
      <h2 className="card__titel">{t.erkennung.titel}</h2>
      <p className="card__lead">{t.erkennung.lead}</p>

      <label className="field field--luft">
        <span className="field__label">{t.erkennung.minuten}</span>
        <input
          className="field__input"
          type="number"
          inputMode="numeric"
          name="stop_minutes"
          value={minuten}
          min={grenzen.stop_minutes.min}
          max={grenzen.stop_minutes.max}
          onChange={(e) => setEntwurf({ ...entwurf, minuten: e.target.value })}
        />
        <span className="feld__hinweis">{t.erkennung.minutenHinweis}</span>
      </label>

      <label className="field field--luft">
        <span className="field__label">{t.erkennung.umkreis}</span>
        <input
          className="field__input"
          type="number"
          inputMode="numeric"
          name="stop_radius_m"
          value={radius}
          min={grenzen.stop_radius_m.min}
          max={grenzen.stop_radius_m.max}
          onChange={(e) => setEntwurf({ ...entwurf, radius: e.target.value })}
        />
        {/* Aus dem Betrieb, und es ist die überraschende Richtung: mehr ist
            hier nicht besser. */}
        <span className="feld__hinweis">{t.erkennung.umkreisHinweis}</span>
      </label>

      {save.isError && (
        <p className="notice" role="alert">
          {fehlertext(save.error)}
        </p>
      )}
      {gemeldet && !save.isPending && (
        <p className="card__lead akzent">
          {t.allgemein.gespeichert}
        </p>
      )}

      <button
        className="button button--outline"
        type="button"
        disabled={!offen || save.isPending}
        onClick={() => {
          setGemeldet(false)
          save.mutate(geaendert(), {
            onSuccess: () => {
              setEntwurf({})
              setGemeldet(true)
            },
          })
        }}
      >
        {save.isPending ? t.allgemein.laeuft : t.allgemein.speichern}
      </button>
    </div>
  )
}
